// cSpell:disable
import { DEFAULT_TIME_FORMAT } from 'common/components/Inputs/TimePicker/constants';
import { ERROR_MESSAGES } from 'common/constants';
import { format, toZonedTime } from 'date-fns-tz';

const DST_NAMES: Record<string, [standard: string, dst: string]> = {
  'America/New_York': ['EST', 'EDT'],
  'Etc/GMT': ['GMT', 'GMT'],
  'Europe/Paris': ['CET', 'CEST'],
};

// Intl.DateTimeFormat short timezone names are locale-dependent (e.g. en-US returns GMT+2
// instead of CEST, other locales return GMT-4 instead of EDT). We use a DST-aware lookup
// table instead, detecting DST by comparing the UTC offset in January (always standard time
// in the Northern Hemisphere) vs the given date.
const getTimezoneAbbr = (date: Date, tz: string): string => {
  const names = DST_NAMES[tz];
  if (!names) return tz;
  const [standard, dst] = names;
  if (standard === dst) return standard;

  const getUTCOffset = (d: Date): number => {
    const tzTime = new Date(d.toLocaleString('en-US', { timeZone: tz }));
    const utcTime = new Date(d.toLocaleString('en-US', { timeZone: 'UTC' }));
    return (tzTime.getTime() - utcTime.getTime()) / 60000;
  };

  const jan = new Date(date.getFullYear(), 0, 1);
  return getUTCOffset(date) !== getUTCOffset(jan) ? dst : standard;
};

export const formatTimeEST = (date: string | number | Date, timeFormat: string = DEFAULT_TIME_FORMAT) => {
  const tz = 'America/New_York';
  try {
    const d = new Date(date);
    return `${format(toZonedTime(d, tz), timeFormat)} (${getTimezoneAbbr(d, tz)})`;
  } catch {
    return ERROR_MESSAGES.invalidTime;
  }
};

export const formatTimeGMT = (date: string | number | Date, timeFormat: string = DEFAULT_TIME_FORMAT) => {
  const tz = 'Etc/GMT';
  try {
    const d = new Date(date);
    return `${format(toZonedTime(d, tz), timeFormat)} (${getTimezoneAbbr(d, tz)})`;
  } catch {
    return ERROR_MESSAGES.invalidTime;
  }
};

export const formatTimeCET = (date: string | number | Date, timeFormat: string = DEFAULT_TIME_FORMAT) => {
  const tz = 'Europe/Paris';
  try {
    const d = new Date(date);
    return `${format(toZonedTime(d, tz), timeFormat)} (${getTimezoneAbbr(d, tz)})`;
  } catch {
    return ERROR_MESSAGES.invalidTime;
  }
};
